import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CompetitorsOutlineComponent } from './competitors-outline/competitors-outline.component';
import { ContentEditorComponent } from './content-editor.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { TextEditorComponent } from './text-editor/text-editor.component';

const routes: Routes = [
  {
    path: '', component: ContentEditorComponent, children: [
      { path: '', redirectTo: 'editors', pathMatch: 'full' },
      { path: 'editors', component: DashboardComponent ,title: "Content Editor | Strell.io"},
      { path: 'editor/:id', component: TextEditorComponent ,title: "Content Editor | Strell.io" },
      { path: 'competitors-outline', component: CompetitorsOutlineComponent ,title: "Content Editor | Strell.io" }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContentEditorRoutingModule { }
